import Button from '@returnmates/ui-core/src/components/Button'
import Modal from '@returnmates/ui-core/src/components/Modal'
import clsx from 'clsx'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import { memo, useCallback, useState } from 'react'

import SingleDatePicker from '../../SingleDatePicker'
import useStyles from '../styles'

interface Props {
  isOpen: boolean
  isLoading: boolean
  handleClose: () => void
  handleSubmit: (date: string) => void
  maxDate?: string | null
}

function AddNewPackageModal({ isOpen, isLoading, handleClose, handleSubmit, maxDate }: Props) {
  const [date, setDate] = useState(momentTimezone(new Date()).format('MM-DD-YYYY'))
  const classes = useStyles()

  const handleDateChange = (date: Date | null) => {
    setDate(moment(date).format('YYYY-MM-DD'))
  }

  const handleConfirmClick = useCallback(() => {
    handleSubmit(date)
  }, [handleSubmit, date])

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width={448}>
      <div className={classes.rescheduleModal}>
        <p className={classes.rescheduleModalHeader}>Reschedule Trip</p>
        <SingleDatePicker
          value={date}
          onChange={handleDateChange}
          momentFormat="YYYY-MM-DD"
          disablePast
          isStatic
          maxDate={maxDate}
        />
        <div className={classes.rescheduleModalButtonsGroup}>
          <Button
            className={clsx(classes.button, classes.saveButton, classes.rescheduleModalButton)}
            onClick={handleConfirmClick}
            isLoading={isLoading}
            label="Confirm"
          />
          <Button
            className={clsx(classes.button, classes.cancelButton, classes.rescheduleModalButton)}
            onClick={handleClose}
            label="Cancel"
            cancelButton
          />
        </div>
      </div>
    </Modal>
  )
}

export default memo(AddNewPackageModal)
